import request from '@/utils/request'

// 查询项目列表
export function listProject(query) {
    return request({
        url: '/project/project/list',
        method: 'get',
        params: query
    })
}

// 查询项目详细
export function getProject(projectId) {
    return request({
        // url: '/project/project/getInfo',
        url: '/project/project/getProjectInfo',
        method: 'get',
        params: {projectId}
    })
}

// 新增项目
export function addProject(data) {
    return request({
        url: '/project/project',
        method: 'post',
        data: data
    })
}

// 修改项目信息
export function projectUpdate(data) {
    return request({
        url: '/project/project/updateInfo',
        method: 'post',
        data: data
    })
}

export function updateProjectEditTask(data) {
    return request({
        url: '/project/project/updateProjectEditTask',
        method: 'post',
        data: data
    })
}

// 修改项目
export function updateProject(data) {
    return request({
        url: '/project/project',
        method: 'put',
        data: data
    })
}

export function updateInfo(data) {
    return request({
        url: '/project/project/updateInfo',
        method: 'post',
        data: data
    })
}

// 删除项目
export function delProject(projectId) {
    return request({
        url: '/project/project/' + projectId,
        method: 'delete'
    })
}

// 更新成员状态
export function updateMemberStatus(data) {
    return request({
        url: '/project/project/updateMemberStatus',
        method: 'post',
        data: data
    })
}

// 项目启动和中止和完成 启动  status=0，中止=2，完成=1
export function projectFinish(data) {
    return request({
        url: '/project/project/projectFinish',
        method: 'post',
        data: data
    })
}

// 任务编排批量删除
export function removeBatch(data) {
    return request({
        url: '/project/task/removeBatch/' + data,
        method: 'delete'
    })
}

// 任务编排上移下移
export function updateOrder(data) {
    return request({
        url: '/project/task/updateOrder',
        method: 'post',
        data: data
    })
}

// 项目工时列表
export function selectProjectHour(query) {
    return request({
        url: '/project/project/selectProjectHour',
        method: 'get',
        params: query
    })
}

// 查询项目基本信息
export function getProjectInfo(projectId) {
    return request({
        url: '/project/project/getProjectInfo?projectId=' + projectId,
        method: 'get'
    })
}
